import dynamic from 'next/dynamic';
const SportStrip = dynamic(() => import('./SportStrip'));
const DriverStrip = dynamic(() => import('./DriverStrip'));

export { SportStrip };
export { DriverStrip };
export { type Details } from './SportStrip';
